<template>
  <div class="loading_container" v-if="loading">
    <div class="spinner-border text-primary" role="status">
      <span class="sr-only"></span>
    </div>
  </div>

  <div class="main" v-else>
    <!-- Side Navbar -->
    <SideBar />
    <!-- Body-Content -->
    <div class="body-content">
      <!-- Top Navbar -->
      <TopBar />
      <!-- Body -->
      <div class="container-fluid body-container">
        <div class="row">
          <div class="col-lg-12">
            <h1>Estatísticas</h1>
            <div class="row">
              <div class="col-md-4 col-sm-12">
                <div class="stati">
                  <div>
                    <div><i class="fa-solid fa-graduation-cap" /> Assistentes ativas</div>
                    <h2>{{ stats.assistants_count }}</h2>
                  </div>
                </div>
              </div>
              <div class="col-md-4 col-sm-12">
                <div class="stati">
                  <div>
                    <div><i class="fa-solid fa-user" /> Clientes ativos</div>
                    <h2>{{ stats.clients_count }}</h2>
                  </div>
                </div>
              </div>
              <div class="col-md-4 col-sm-12">
                <div class="stati">
                  <div>
                    <div><i class="fa-solid fa-briefcase" /> Projetos ativos</div>
                    <h2>{{ stats.projects_count }}</h2>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-4 col-sm-12">
                <div class="stati">
                  <div>
                    <div><i class="fa-solid fa-file-alt" /> Propostas ativas</div>
                    <h2>{{ stats.proposals_count }}</h2>
                  </div>
                </div>
              </div>
              <div class="col-md-4 col-sm-12">
                <div class="stati">
                  <div>
                    <div><i class="fa-solid fa-handshake" /> Contratações</div>
                    <h2>{{ stats.hires_count }}</h2>
                  </div>
                </div>
              </div>
              <div class="col-md-4 col-sm-12">
                <div class="stati">
                  <div>
                    <div><i class="fa-solid fa-star" /> Feedbacks</div>
                    <h2>{{ stats.reviews_count }}</h2>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row mt-4">
          <div class="col-lg-12">
            <h1>Relatórios</h1>

            <div class="row">
              <div class="col-md-4 col-sm-12">
                <div class="stati">
                  <button class="btn btn-small" @click="allAssistants()">
                    Lista de assistentes
                  </button>
                </div>
              </div>
              <div class="col-md-4 col-sm-12">
                <div class="stati">
                  <button class="btn btn-small" @click="allClients()">
                    Lista de clientes
                  </button>
                </div>
              </div>
              <div class="col-md-4 col-sm-12">
                <div class="stati">
                  <button class="btn btn-small" @click="allProjects()">
                    Lista de projetos
                  </button>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-4 col-sm-12">
                <div class="stati">
                  <button class="btn btn-small" @click="allReleasedContacts()">
                    Lista de propostas aceitas
                  </button>
                </div>
              </div>
              <div class="col-md-4 col-sm-12">
                <div class="stati">
                  <button class="btn btn-small" @click="allHires()">
                    Lista de contratações
                  </button>
                </div>
              </div>
              <div class="col-md-4 col-sm-12">
                <div class="stati">
                  <button class="btn btn-small" @click="allReviews()">
                    Lista de feedbacks
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import SideBar from "../SideBar.vue";
import TopBar from "../TopBar.vue";
import SupportManager from "../../../js/services/support.js";
import StringUtils from "../../../js/utils/string.js";
import Config from "../../../../resources/config.js";

export default {
  components: { SideBar, TopBar },

  created() {
    this.$store.commit("setActiveSection", "DashboardPage");
    this.$store.commit("setActiveProjectList", null);
    this.loadSupportData();
  },

  data() {
    return {
      profile: null,
      stats: null,
    };
  },

  computed: {
    loading() {
      return this.$store.state.loading;
    },
  },

  methods: {
    async loadSupportData() {
      this.$store.commit("setLoading", true);

      try {
        let supportData = await SupportManager.getSupportData();
        this.profile = supportData.profile;

        if (!this.profile) {
          window.location = "/cadastro";
        } else {
          this.stats = supportData.stats;
          this.$store.commit("setActiveUser", this.profile);
          this.$store.commit("setLoading", false);
        }
      } catch (error) {
        this.handleAPIError(error, null);
      }
    },

    allAssistants() {
      let url = `${Config.apiHost}/support/reports/assistants`;
      window.open(url);
    },

    allClients() {
      let url = `${Config.apiHost}/support/reports/clients`;
      window.open(url);
    },

    allProjects() {
      let url = `${Config.apiHost}/support/reports/projects`;
      window.open(url);
    },

    allReleasedContacts() {
      let url = `${Config.apiHost}/support/reports/accepted-proposals`;
      window.open(url);
    },

    allHires() {
      let url = `${Config.apiHost}/support/reports/hires`;
      window.open(url);
    },

    allReviews() {
      let url = `${Config.apiHost}/support/reports/reviews`;
      window.open(url);
    },

    syncStripe() {
      SupportManager.syncStripe();
    },

    syncOrders() {
      SupportManager.syncOrders();
    },

    syncNFs() {
      let url = `${Config.apiHost}/support/sync-nfs`;
      window.open(url);
    },

    syncHires() {
      let url = `${Config.apiHost}/support/sync-hires`;
      window.open(url);
    },

    syncStreaming() {
      let url = `${Config.apiHost}/support/sync-streaming`;
      window.open(url);
    },

    generatePaymentLink() {
      let $ctx = this;
      let $modal = $("#generatePaymentLinkModal");
      $modal.find(".item").removeClass("error");

      function addOrUpdateQueryParam(url, key, value) {
        const u = new URL(url, window.location.origin);
        u.searchParams.set(key, value);
        return u.toString();
      }

      let action = async function () {
        let hasError = false;
        $modal.find(".item").removeClass("error");

        const preco = parseFloat(document.getElementById("preco").value) || 0;
        const precoCentavos = Math.round(preco * 100);
        const orderReference = $("#link_order_reference").val();
        const linkDuration = Number($("#link_duration").val()) * 3600;

        const installments = [[precoCentavos, precoCentavos]];

        document.querySelectorAll("tbody tr").forEach((row) => {
          const parcelaCentavos = parseInt(row.dataset.parcelaCentavos) || 0;
          const totalCentavos = parseInt(row.dataset.totalCentavos) || 0;

          installments.push([parcelaCentavos, totalCentavos]);
        });

        let details = {
          orderRef: orderReference.toUpperCase(),
          installments,
        };

        if (hasError) {
          return false;
        }

        let response = await SupportManager.generatePaymentLink(linkDuration, details);
        let url = addOrUpdateQueryParam(
          `${Config.publicSite}/comprar`,
          "rsrc",
          response.token
        );
        window.open(url);
        return true;
      };

      this.showModal(
        $modal,
        function () {},
        "Gerar link",
        action,
        "Link gerado.",
        "Ocorreu um erro gerar o link.\nPor favor, tente novamente."
      );
    },
  },
};
</script>
